import React, { useEffect, useState } from 'react' 
import { getNews } from '../Service/Api';
const KioskNews = () => {
  const [data, setData] = useState([]); // State for gallery data
  const [loading, setLoading] = useState(true); // State for loading indicator 

  useEffect(() => {
    const fetchData = async () => {
      try {
        const topperData = await getNews();
        console.log(topperData)
        setData(topperData);
      } catch (error) {
        console.error("Error fetching gallery data:", error);
        // Handle error (e.g., show error message)
      } finally {
        setLoading(false); // Set loading to false after data fetching is complete
      }
    };
    fetchData();
  }, []);
  
  return (
   <>
    {data.length > 0 ? (data.map((item, index) => (
          <div className="homenews" key={index}>
          <h3>{item.title}</h3>
          <p>{item.description}</p>
       </div>
    // <NewsProps href="link" title={item.title} desc={item.description} image={"Images/gal.jpeg"}  key={index} />
    ))
    
    ):(<div className="homenews">
    <h3>News Title</h3>
    <p>Stay tuned for more information about latest updates.</p>
 </div>)}
    {/* <NewsProps href="link" title="Headlines - 1" desc="Stay tuned for more information about latest updates." image={"Images/gal.jpeg"}/>
    <NewsProps href="link" title="Headlines - 1" desc="Stay tuned for more information about latest updates." image={"Images/gal.jpeg"}/>
    <NewsProps href="link" title="Headlines - 1" desc="Stay tuned for more information about latest updates." image={"Images/gal.jpeg"}/> */}
   </>
  )
}

export default KioskNews
